/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRoadsideService48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={68}
      height={52}
      fill='none'
      viewBox='0 0 68 52'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M12.476 48.533c2.916 0 5.28-2.529 5.28-5.65 0-3.12-2.364-5.649-5.28-5.649-2.916 0-5.28 2.53-5.28 5.65 0 3.12 2.364 5.65 5.28 5.65z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M55.2 23.776h1.954c.512 0 .926.443.926.991v3.497c0 .545-.414.99-.926.99H55.2v-5.478z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M26.694 48.533c2.916 0 5.28-2.529 5.28-5.65 0-3.12-2.364-5.649-5.28-5.649-2.916 0-5.28 2.53-5.28 5.65 0 3.12 2.364 5.65 5.28 5.65zM55.61 48.533c2.916 0 5.28-2.529 5.28-5.65 0-3.12-2.364-5.649-5.28-5.649-2.916 0-5.28 2.53-5.28 5.65 0 3.12 2.364 5.65 5.28 5.65z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={1.5}
        strokeWidth={1.5}
        d='M54.89 42.884h1.44M25.92 42.884h1.44M11.52 42.884h1.44'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M60.96 43.806h5.064V32.95c0-.58-.306-1.113-.79-1.374l-6.976-3.774M42.72 26.91v16.896h7.2'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M2.868 43.806H6.72'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M57.25 23.866l-2.6-9.848H42.72v12.891h10.182'
      />
      <path
        stroke='currentColor'
        strokeWidth={1.5}
        d='M49.92 11.45c0-.852-.644-1.54-1.44-1.54H48c-.796 0-1.44.688-1.44 1.54v2.568h3.36V11.45z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M31.67 43.806h11.374M17.76 43.806h3.958M.498 34.283l2.026-.528 34.122-9.127'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M2.868 43.644v-9.082h40.176'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M32.382 26.15l2.118 8.178'
      />
      <path stroke='currentColor' strokeWidth={1.5} d='M60.96 40.725h4.8' />
    </svg>
  );
}

export default SvgRoadsideService48;
